<template>
  <component
    :is="tag"
    class="icon"
    :class="computedClasses"
    aria-label="icon"
  />
</template>

<script lang="ts">
  import Vue from "vue";
  import {EColor} from "~/enums/eColor";
  import {eColors} from "~/modules/gColors/colors";
  import {Logger} from "~/services/logger";

  export default Vue.extend({
    props: {
      color: {
        type: String as () => EColor,
        default: ""
      },
      tag: {
        type: String,
        default: 'span'
      },
      glyph: {
        type: String
      },
      direction: {
        type: String
      },
    },
    computed: {
      itemColor() {
        if(eColors.includes(this.color)){
          return EColor[this.color];
        } else if(this.color === "") {
          return "";
        }
        else {
          Logger.errorOnce('Icon', 'Color not available for the icon.', 'Try one of these values instead:', eColors);
          return "color-unavailable";
        }
      },
      computedClasses(){
        return [
          this.itemColor,
          this.glyph,
          this.direction,
          {
            'colorized': this.color !== ''
          }
        ]
      },
    }
  });
</script>
